import { SEO } from '@/components/feature/SEO';
import { getHotComics, getNewComics, getTopRatedComics, categories } from '@/mocks/comics';
import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const hotComics = getHotComics();
  const newComics = getNewComics();
  const topRated = getTopRatedComics();

  const featuredComics = [
    { id: 5, title: '龙之继承者', author: '郑宇成', category: 'fantasy', status: '连载中', rating: 9.8, views: 3200000, description: '平凡少年意外觉醒了龙族血脉，从此踏上修炼之路。', chapters: 210, updateDate: '2026-08-04', coverUrl: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20Korean%20manhwa%20cover%20art%20style%2C%20heroic%20dragon%20theme%20character%20illustration%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20vibrant%20golden%20colors%20with%20majestic%20composition&width=600&height=800&seq=comic-cover-05&orientation=portrait', thumbUrl: '' },
    { id: 3, title: '暗夜追踪者', author: '朴志勋', category: 'thriller', status: '连载中', rating: 9.7, views: 1890000, description: '前刑警因一桩悬案被卷入连环杀人事件。', chapters: 72, updateDate: '2026-08-03', coverUrl: 'https://readdy.ai/api/search-image?query=Thriller%20Korean%20manhwa%20cover%20art%20style%2C%20mysterious%20dark%20atmosphere%20character%20illustration%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20deep%20colors%20with%20dramatic%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait', thumbUrl: '' },
    { id: 8, title: '末日生存法则', author: '张东健', category: 'action', status: '连载中', rating: 9.6, views: 2750000, description: '末日降临，丧尸横行。', chapters: 165, updateDate: '2026-08-04', coverUrl: 'https://readdy.ai/api/search-image?query=Post-apocalyptic%20Korean%20manhwa%20cover%20art%20style%2C%20survival%20theme%20character%20illustration%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20dark%20desaturated%20colors%20with%20dramatic%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait', thumbUrl: '' },
    { id: 15, title: '魔剑士传说', author: '安宰贤', category: 'fantasy', status: '连载中', rating: 9.6, views: 1980000, description: '在魔法与剑并存的异世界中。', chapters: 178, updateDate: '2026-08-04', coverUrl: 'https://readdy.ai/api/search-image?query=Magic%20sword%20fantasy%20Korean%20manhwa%20cover%20art%20style%2C%20heroic%20warrior%20character%20illustration%2C%20clean%20minimalist%20design%2C%20modern%20webtoon%20aesthetic%2C%20magical%20purple%20tone%20colors%20with%20epic%20composition&width=600&height=800&seq=comic-cover-15&orientation=portrait', thumbUrl: '' },
  ];

  const formatViews = (v: number) => {
    if (v >= 10000) return (v / 10000).toFixed(1) + '万';
    return v.toString();
  };

  return (
    <>
      <SEO
        title="韩漫大全_高清韩国漫画_漫画韩漫网址_免费韩漫在线阅读-韩漫网"
        description="韩漫网致力于为您提供高清韩国漫画的免费在线阅读，拥有丰富韩漫大全和易用网址，覆盖恋爱、奇幻、动作、悬疑等多种类型，每日更新最新韩漫章节，让您尽情享受阅读的快乐。"
        keywords="韩漫大全,高清韩国漫画,漫画韩漫网址,免费韩漫在线阅读,韩漫网,韩国漫画,韩漫推荐,最新韩漫"
        canonicalUrl="https://www.hanmanwang.com/"
        schemaType="WebSite"
      />

      <main className="pt-16">
        {/* Hero Section */}
        <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%2C%20dreamy%20fantasy%20landscape%20with%20soft%20warm%20lighting%2C%20ethereal%20atmosphere%2C%20artistic%20comic%20background%20with%20subtle%20gradients%2C%20gentle%20color%20palette%20with%20peach%20and%20cream%20tones%2C%20minimalist%20elegant%20design&width=1920&height=620&seq=hero-bg-2026&orientation=landscape"
            alt="韩漫网 - 高清韩国漫画在线阅读"
            title="韩漫网 - 高清韩国漫画"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4 tracking-wide">
              韩漫网
            </h1>
            <p className="text-base md:text-lg text-background-200 max-w-2xl leading-relaxed mb-8">
              高清韩国漫画免费在线阅读平台，海量<strong>韩漫大全</strong>每日更新，
              覆盖恋爱、奇幻、动作、悬疑等多种类型，为您提供极致的<strong>漫画韩漫网址</strong>阅读体验
            </p>
            <div className="flex items-center gap-4 flex-wrap justify-center">
              <Link
                to="/category/all"
                className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                浏览漫画
              </Link>
              <Link
                to="/about"
                className="px-6 py-3 bg-background-50/20 hover:bg-background-50/30 text-background-50 font-medium rounded-lg border border-background-50/30 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="w-full px-4 md:px-6 py-8 bg-background-100">
          <div className="flex items-center gap-3 flex-wrap justify-center">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:text-primary-600 text-sm text-foreground-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-sm`}></i>
                </div>
                <span>{cat.name}</span>
              </Link>
            ))}
          </div>
        </section>

        {/* Featured Comics */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="mb-6">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最受欢迎的<strong>高清韩国漫画</strong>精选</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
            {featuredComics.map((comic) => (
              <ComicCard key={comic.id} {...comic} />
            ))}
          </div>
        </section>

        {/* Hot Comics */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                热门排行
              </h2>
              <p className="text-sm text-foreground-500 mt-1">本周最热<strong>韩国漫画</strong></p>
            </div>
            <Link
              to="/category/all"
              className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
            >
              查看全部
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-product-shop="">
            {hotComics.map((comic, index) => (
              <Link
                key={comic.id}
                to={`/article/${comic.id}`}
                className="flex items-center gap-4 p-3 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer group"
              >
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                  <span className={`text-lg font-bold font-heading ${
                    index === 0 ? 'text-primary-500' :
                    index === 1 ? 'text-accent-500' :
                    index === 2 ? 'text-secondary-500' :
                    'text-foreground-400'
                  }`}>
                    {index + 1}
                  </span>
                </div>
                <div className="w-12 h-16 flex-shrink-0 rounded overflow-hidden">
                  <img
                    src={comic.thumbUrl}
                    alt={comic.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
                  <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-400">
                    <span className="text-primary-500 font-medium">{comic.rating}</span>
                    <span>共{comic.chapters}话</span>
                    <span className={`${comic.status === '已完结' ? 'text-accent-500' : 'text-secondary-500'}`}>
                      {comic.status}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </section>

        {/* Latest Updates */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                最新更新
              </h2>
              <p className="text-sm text-foreground-500 mt-1">每日更新最新<strong>韩漫大全</strong>章节</p>
            </div>
            <Link
              to="/category/all"
              className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
            >
              查看全部
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
            {newComics.map((comic) => (
              <ComicCard key={comic.id} {...comic} />
            ))}
          </div>
        </section>

        {/* Top Rated Section */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="mb-6">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              高分神作
            </h2>
            <p className="text-sm text-foreground-500 mt-1">读者评分最高的<strong>免费韩漫在线阅读</strong>推荐</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4" data-product-shop="">
            {topRated.map((comic, index) => (
              <Link
                key={comic.id}
                to={`/article/${comic.id}`}
                className="group block bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all overflow-hidden cursor-pointer"
              >
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img
                    src={comic.coverUrl}
                    alt={comic.title}
                    title={`${comic.title} - 高清韩国漫画`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-2 left-2">
                    <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs rounded-md font-bold">
                      TOP {index + 1}
                    </span>
                  </div>
                </div>
                <div className="p-3">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">{comic.title}</h3>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-primary-500 font-medium">{comic.rating}</span>
                    <span className="text-xs text-foreground-500">{formatViews(comic.views)} 阅读</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </section>

        {/* CTA Section */}
        <section className="w-full px-4 md:px-6 py-14 md:py-20 relative overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20background%2C%20soft%20dreamy%20atmosphere%2C%20warm%20peach%20and%20cream%20gradient%2C%20elegant%20minimalist%20illustration%2C%20subtle%20texture%2C%20ethereal%20lighting&width=1920&height=400&seq=cta-bg-2026&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-background-900/50"></div>
          <div className="relative z-10 flex flex-col items-center text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
              开始你的韩漫之旅
            </h2>
            <p className="text-sm md:text-base text-background-200 max-w-lg mb-6 leading-relaxed">
              海量<strong>高清韩国漫画</strong>等你来发现，随时随地免费在线阅读，享受极致漫画体验
            </p>
            <Link
              to="/category/all"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              立即探索
            </Link>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-8">
              常见问题
            </h2>
            <div className="space-y-3">
              {[
                { q: '韩漫网是什么？', a: '韩漫网是一个专注于高清韩国漫画在线免费阅读的平台，提供丰富的韩漫大全资源，涵盖恋爱、奇幻、动作、悬疑等多种类型，每日更新最新章节。' },
                { q: '如何开始阅读漫画？', a: '您可以直接在首页浏览推荐和热门漫画，或通过分类导航找到感兴趣的漫画类型，点击即可开始免费在线阅读。' },
                { q: '需要注册账号吗？', a: '不需要！韩漫网所有漫画均可免费在线阅读，无需注册或登录，打开网站即可畅享阅读体验。' },
                { q: '漫画更新频率如何？', a: '我们每日追踪最新韩国漫画更新，确保您第一时间看到最新连载章节，热门作品通常每周更新。' },
              ].map((faq, index) => (
                <details key={index} className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden group cursor-pointer">
                  <summary className="px-5 py-4 flex items-center justify-between text-sm font-medium text-foreground-800 hover:text-primary-600 transition-colors">
                    {faq.q}
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                    </div>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      {/* JSON-LD Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "韩漫网",
            url: "https://www.hanmanwang.com/",
            description: "韩漫网致力于为您提供高清韩国漫画的免费在线阅读，拥有丰富韩漫大全和易用网址，覆盖多种类型。",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://www.hanmanwang.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "韩漫网",
            url: "https://www.hanmanwang.com/",
            description: "高清韩国漫画免费在线阅读平台",
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+86-400-888-8888",
              contactType: "customer service",
              availableLanguage: ["Chinese"],
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              { "@type": "Question", name: "韩漫网是什么？", acceptedAnswer: { "@type": "Answer", text: "韩漫网是一个专注于高清韩国漫画在线免费阅读的平台，提供丰富的韩漫大全资源，涵盖恋爱、奇幻、动作、悬疑等多种类型，每日更新最新章节。" } },
              { "@type": "Question", name: "如何开始阅读漫画？", acceptedAnswer: { "@type": "Answer", text: "您可以直接在首页浏览推荐和热门漫画，或通过分类导航找到感兴趣的漫画类型，点击即可开始免费在线阅读。" } },
              { "@type": "Question", name: "需要注册账号吗？", acceptedAnswer: { "@type": "Answer", text: "不需要！韩漫网所有漫画均可免费在线阅读，无需注册或登录，打开网站即可畅享阅读体验。" } },
              { "@type": "Question", name: "漫画更新频率如何？", acceptedAnswer: { "@type": "Answer", text: "我们每日追踪最新韩国漫画更新，确保您第一时间看到最新连载章节，热门作品通常每周更新。" } },
            ],
          }),
        }}
      />
    </>
  );
}